import { useCallback, useEffect, useState } from 'react';
import { api, errorMessage, LOGIN_URL, type DefaultTarget, type Me } from './api';
import { Alert } from './components/Alert';
import { Header } from './components/Header';
import { Admin } from './pages/Admin';
import { Home } from './pages/Home';
import { InstanceDetail } from './pages/InstanceDetail';
import { Link, useLocation } from './router';

function LoggedOut() {
  return (
    <main className="container">
      <section>
        <h1>Vous êtes déconnecté</h1>
        <p className="muted">Votre session WHCC est fermée.</p>
        <p>
          <a className="btn" href={LOGIN_URL}>
            Se reconnecter
          </a>
        </p>
      </section>
    </main>
  );
}

export function App() {
  const { pathname } = useLocation();
  if (pathname.replace(/\/+$/, '') === '/logged-out') return <LoggedOut />;
  return <Authenticated />;
}

function Authenticated() {
  const [me, setMe] = useState<Me | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    let cancelled = false;
    api.me().then(
      (m) => !cancelled && setMe(m),
      (e: unknown) => !cancelled && setError(errorMessage(e)),
    );
    return () => {
      cancelled = true;
    };
  }, []);

  const onPreference = useCallback((defaultTarget: DefaultTarget) => {
    setMe((m) => (m ? { ...m, defaultTarget } : m));
  }, []);

  if (error) {
    return (
      <main className="container">
        <Alert>{error}</Alert>
      </main>
    );
  }
  if (!me) {
    return (
      <main className="container" aria-busy="true">
        <p className="muted">Chargement…</p>
      </main>
    );
  }

  const path = pathname.replace(/\/+$/, '') || '/';
  let page;
  if (path === '/') page = <Home me={me} onPreferenceChange={onPreference} />;
  else if (path === '/admin') {
    page = me.isAdmin ? <Admin me={me} /> : <Alert>Accès réservé aux administrateurs.</Alert>;
  } else if (/^\/admin\/instances\/[^/]+$/.test(path)) {
    const instanceId = decodeURIComponent(path.split('/')[3] ?? '');
    page = me.isAdmin ? (
      <InstanceDetail key={instanceId} me={me} instanceId={instanceId} />
    ) : (
      <Alert>Accès réservé aux administrateurs.</Alert>
    );
  } else {
    page = (
      <section>
        <h1>Page introuvable</h1>
        <p>
          <Link href="/">Retour à mes instances</Link>
        </p>
      </section>
    );
  }

  return (
    <>
      <a className="skip-link" href="#contenu">
        Aller au contenu
      </a>
      <Header me={me} />
      <main id="contenu" className="container" tabIndex={-1}>
        {page}
      </main>
    </>
  );
}
